module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-9.0d78356d.png";